import HistTemperatureRisk from "./HistTemperatureRisk";

export default HistTemperatureRisk;